export type Permission = typeof Permission[keyof typeof Permission];
export const Permission = {
    BillingCanEdit: "Billing.can-edit",
    BillingCanList: "Billing.can-list",
    ClubCanList: "Club.can-list",
    ClubCanEdit: "Club.can-edit",
    EventFamiliesCanList: "EventFamilies.can-list",
    EventFamiliesCanEdit: "EventFamilies.can-edit",
    EventsCanRegisterMember: "Events.can-register-member",
    EventsCanMarkMemberAttends: "Events.can-mark-member-attends",
    EventsCanEdit: "Events.can-edit",
    EventTypesCanEdit: "EventTypes.can-edit",
    EventTypesCanList: "EventTypes.can-list",
    MemberMemberShipsCanList: "MemberMemberShips.can-list",
    MemberMemberShipsCanEdit: "MemberMemberShips.can-edit",
    MembersCanEdit: "Members.can-edit",
    MembersCanList: "Members.can-list",
    MemberShipsCanEdit: "MemberShips.can-edit",
    MemberShipsCanList: "MemberShips.can-list",
    PaymentPlansCanList: "PaymentPlans.can-list",
    PaymentPlansCanEdit: "PaymentPlans.can-edit",
    ReconciliationCanList: "Reconciliation.can-list",
    ReconciliationCanEdit: "Reconciliation.can-edit",
    TagsCanEdit: "Tags.can-edit",
    TagsCanList: "Tags.can-list",
    UserImagesCanValidate: "UserImages.can-validate",
    WorkoutCanEdit: "Workout.can-edit",
    WorkoutCanList: "Workout.can-list",
    ZonesCanEdit: "Zones.can-edit",
    ZonesCanList: "Zones.can-list",
    InvoiceCanList: "Invoice.can-list",
    InvoiceCanEdit: "Invoice.can-edit",
    CommunicationInternalCanList: "InternalMessages.can-list",
    CommunicationInternalCanEdit: "InternalMessages.can-edit",
    CommunicationExternalCanEdit: "Communication.external.can-edit",
    CommunicationTemplateCanEdit: "Communication.template.can-edit",
    CommunicationHistoryCanList: "Communication.history.can-list",
    PosCanRead: "Pos.can-read",
    PosCanWrite: "Pos.can-write"

} as const;